import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SourceForm } from '@/features/sources/components/SourceForm/SourceForm';
import { useSource } from '@/features/sources/hooks/useSource';
import { useUpdateSource } from '@/features/sources/hooks/useUpdateSource';
import { ComponentLoadError } from '@/shared/components/alerts/ComponentLoadError';
import type { SourceFormData } from '@/features/sources/types/source.types';

export const Route = createFileRoute('/_auth/sources/edit/$sourceId')({
  component: EditSourcePage,
});

function EditSourcePage() {
  const { sourceId } = Route.useParams();
  const navigate = useNavigate();

  const { source, isLoading, isError } = useSource({
    sourceId: Number(sourceId),
  });

  const updateMutation = useUpdateSource();

  const handleSubmit = (data: SourceFormData) => {
    updateMutation.mutate(
      { id: Number(sourceId), data },
      {
        onSuccess: () => {
          navigate({ to: '/sources' });
        },
      }
    );
  };

  const handleCancel = () => {
    navigate({ to: '/sources' });
  };

  if (isLoading) {
    return (
      <div className="max-w-3xl mx-auto">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gray-200 rounded w-1/3"></div>
          <div className="h-64 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  if (isError || !source) {
    return (
      <div className="max-w-3xl mx-auto">
        <ComponentLoadError componentName="Edit Source" />
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <SourceForm
        initialData={source}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isSubmitting={updateMutation.isPending}
      />
    </div>
  );
}
